var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bet-detail-wrapper" }, [
    _vm.currentTicket
      ? _c("div", { staticClass: "ticket-header" }, [
          _c("span", { staticClass: "ticket-header__number" }, [
            _vm._v(" " + _vm._s(_vm.roundLabel) + " "),
          ]),
          _c(
            "div",
            { staticClass: "ticket-header__id" },
            [
              _c("span", { staticClass: "ticket-header__id-text" }, [
                _vm._v(_vm._s(_vm.currentTicket.sid)),
              ]),
              _c("CopyBtn", { attrs: { targetTxt: _vm.currentTicket.sid } }),
            ],
            1
          ),
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "result-main-body" },
      [_c("BetDetailTable", { attrs: { ticket: _vm.currentTicket } })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }